import React from 'react';
import { Link } from 'react-router-dom';
import './style1.css';

const AdminPanel2: React.FC = () => (
    <div
        className="admin-panel"
        style={{
            background: '#6a11cb', // Left color of your gradient
            borderRadius: 12,
            boxShadow: '0 2px 16px #6a11cb22',
            padding: '1.5rem',
            margin: '1rem',
            minWidth: 180
        }}
    >
        <h3 style={{ textAlign: 'center', marginBottom: '1rem', color: '#fff' }}>Admin Panel</h3>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '1rem' }}>
                <Link to="/adddemo" className="modern-nav-link" style={{ color: '#fff', textDecoration: 'none', fontWeight: 'bold' }}>
                    Add Demo
                </Link>
            </li>
            <li style={{ marginBottom: '1rem' }}>
                <Link to="/deletedemo" className="modern-nav-link" style={{ color: '#fff', textDecoration: 'none', fontWeight: 'bold' }}>
                    Delete Demo
                </Link>
            </li>
            <li style={{ marginBottom: '1rem' }}>
                <Link to="/addimage" className="modern-nav-link" style={{ color: '#fff', textDecoration: 'none', fontWeight: 'bold' }}>
                    Add Image
                </Link>
            </li>
            <li>
                <Link to="/deleteimage" className="modern-nav-link" style={{ color: '#fff', textDecoration: 'none', fontWeight: 'bold' }}>
                    Delete Image
                </Link>
            </li>
        </ul>
    </div>
);

export default AdminPanel2;